const hostname = typeof window !== "undefined" ? window.location.hostname : "";
const isLocal = hostname === "localhost" || hostname === "127.0.0.1";

const envApiBase = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");

export const API_BASE =
  envApiBase ||
  (isLocal && !process.env.REACT_APP_FORCE_PROD_API
    ? `http://${hostname || "localhost"}:5000`
    : "");

export function resolveMediaUrl(imagePath) {
  if (!imagePath) return imagePath;
  const pathStr = String(imagePath);
  if (pathStr.startsWith("http://") || pathStr.startsWith("https://")) {
    return pathStr;
  }
  if (pathStr.startsWith("/uploads/") && API_BASE) {
    return `${API_BASE}${pathStr}`;
  }
  return pathStr;
}
